import { Box, FeaturedIcons, Flex, Tab, Tooltip } from '@agrotoken-tech/ui';
import { STATUS_ICON } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { VALIDATION_STATUSES, ValidationStatus } from '@bcba/types';
import { PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  status?: ValidationStatus;
  icon?: ReactNode;
}

const statusVariant = {
  [VALIDATION_STATUSES.PENDING_APPROVAL]: 'primary',
  [VALIDATION_STATUSES.INCOMPLETE]: 'warning',
  [VALIDATION_STATUSES.PENDING_CHANGE_REQUEST]: 'destructive',
  [VALIDATION_STATUSES.REJECTED]: 'destructive',
  [VALIDATION_STATUSES.APPROVED]: 'success',
} as const;

export const AsideTab = ({ children, status, icon }: Props) => {
  const { t } = useTranslation();
  const statusLabel = status ? t(`validationStatus.${status}`) : '';

  return (
    <Tab justifyContent={'start'} border={'none'} py={3}>
      <Flex gap={2} alignItems={'center'}>
        <Tooltip
          hasArrow
          label={statusLabel}
          title={statusLabel}
          placement="bottom"
          bg="white"
          color="content-secondary"
          size="sm"
          minW={'auto'}
        >
          <Box>
            {icon}
            {status && !icon ? (
              <FeaturedIcons
                icon={STATUS_ICON[status]}
                variant={statusVariant[status]}
                size="sm"
              />
            ) : null}
          </Box>
        </Tooltip>
        {children}
      </Flex>
    </Tab>
  );
};
